import { INDIA_COUNTRY_CODE } from "constants/countryCodes";
import {
  QUICK_NAV_CONDITION,
  QuickNavCondition,
  QuickNavPage,
} from "constants/quickNav/types";
import { BrowserWindow } from "components/icons/BrowserWindow";
import { useConstructInternalLink } from "hooks/useConstructInternalLink";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useMyPermissions } from "hooks/useMyPermissions";
import { ComponentType } from "react";

export type QuickNavLink = {
  value: string;
  name: string;
  to: string;
  icon: ComponentType;
};

export const useQuickNavLinks = (pages: QuickNavPage[]): QuickNavLink[] => {
  const { link } = useConstructInternalLink();
  const { entities, is_pre_incorporate } = useCurrentGroupContext();
  const { isSuperAdmin, isLoading, hasPermission } = useMyPermissions();

  const conditionMet: Record<QuickNavCondition, boolean> = {
    [QUICK_NAV_CONDITION.PRE_INCORPORATE]: Boolean(is_pre_incorporate),
    [QUICK_NAV_CONDITION.HAS_INDIAN_ENTITY]: entities.some(
      ({ country_code }) => country_code === INDIA_COUNTRY_CODE
    ),
  };

  const isAllowed = ({ permissionKey, conditions = [] }: QuickNavPage) => {
    const hasAccess =
      !permissionKey ||
      isSuperAdmin ||
      isLoading ||
      hasPermission(permissionKey);

    return (
      hasAccess && conditions.every((condition) => conditionMet[condition])
    );
  };

  const toLink = ({
    name,
    path,
    query,
    icon = BrowserWindow,
  }: QuickNavPage): QuickNavLink => ({
    value: name,
    name,
    to: link(path, { moreQuery: query }),
    icon,
  });

  return pages.filter(isAllowed).map(toLink);
};
